<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="Career"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/about-career-01.webp"
            class="grey lighten-2"
            cover
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <v-row
              class="fill-height overlay mx-0"
              align="center"
              justify="center">
              <v-col class="">
                <v-row>
                  <v-col class="text-center">
                    <span class="mr-4 subsite-title-1" style="line-height:6rem;">{{ $t('rubin.rubin') }}</span>
                    <span class="subsite-title-2" style="line-height:3rem;">{{ $t('career.title') }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center subsite-title-3">
                    {{ $t("career.subtitle") }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- ic img -->
            <v-row class="carousel-bottom-controls">
              <v-col class="pa-0 img-ic-box flip-x">
              </v-col>
            </v-row>

            <!-- landing scroll menu -->
            <v-row class="menu landing-scroll">
              <v-col class="max-width-1200 px-0 mx-auto">
                <v-btn
                  v-for="(item,index) in sections"
                  :key="index"
                  text
                  @click="scrollTOSection(item.id)">
                    {{ $t(item.title) }}
                </v-btn>
                <!-- <a
                  v-for="(item,index) in sections"
                  :key="index"
                  :href="'#' + item.id">
                  <div id="btn1" class="button">
                    <h1>{{ $t(item.title) }}</h1>
                  </div>
                </a> -->
              </v-col>
            </v-row>
          </v-img>
        </v-card>

        <v-row class="mx-1">
          <v-col id="pros">
            <Pros></Pros>
          </v-col>
        </v-row>


        <v-row class="mx-1">
          <v-col id="openPositions">
            <OpenPositions></OpenPositions>
          </v-col>
        </v-row>

        <v-row class="mx-1">
          <v-col id="process">
            <Process></Process>
          </v-col>
        </v-row>

        <v-row class="mx-0 my-6 bg-ruby">
          <v-col id="apply">
            <Apply></Apply>
          </v-col>
        </v-row>

        <v-row class="mx-1">
          <v-col id="benefits">
            <Benefits></Benefits>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-ruby">
          <v-col>
            <Contact></Contact>
          </v-col>
        </v-row>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import Pros             from '@/components/Career/Pros.vue'
  import OpenPositions    from '@/components/Career/OpenPositions.vue'
  import Benefits         from '@/components/Career/Benefits.vue'
  import Process          from '@/components/Career/Process.vue'
  import Apply            from '@/components/Career/Apply.vue'
  import Contact          from '@/components/Common/Contact.vue'

  export default {
    name: 'Career',
    metaInfo: {
      title: 'Karrier',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Karrier lehetőség a Rubin Informartikánál. Megbecsülünk és számítunk rád. Csatlakozz a Rubin csapatához!'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Rubin Informatika, IT, karrier, nyitott pozíció, munka, lehetőség'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      Pros,
      OpenPositions,
      Process,
      Benefits,
      Apply,
      Contact,
    },

    data: () => ({
      sections: [
        { id: "pros",             title: "common.about", },
        { id: "openPositions",    title: "career.openPositions.title", },
        { id: "process",          title: "career.process.title", },
        { id: "apply",            title: "career.apply.title", },
        { id: "benefits",         title: "career.benefits.title", },
      ],

    }),

    mounted() {
    },

    computed: {
      mini() {
        if (this.computedWidth < 800) {
          return true
        } else {
          return false
        }
      },

    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },

    watch: {
      computedWidth() {
      }
    },
  }

</script>

<style src="../Style.css">
</style>
